import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Portfolio } from './components/Portfolio';
import { BusinessProgram } from './components/BusinessProgram';
import { FormulaSection } from './components/FormulaSection';
import { Challenges } from './components/Challenges';
import { Results } from './components/Results';
import { Journey } from './components/Journey';
import { Program } from './components/Program';
import { Tariffs } from './components/Tariffs';
import { Speaker } from './components/Speaker';
import { Roadmap } from './components/Roadmap';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SurveyModal } from './components/SurveyModal';
import { DiagnosticSection } from './components/DiagnosticSection';
export function App() {
  return <div className="min-h-screen bg-transparent text-white font-sans selection:bg-blue-500/30" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Stats data-id="element-4" />
        <Portfolio data-id="element-5" />
        <BusinessProgram data-id="element-6" />
        <FormulaSection data-id="element-7" />
        <Challenges data-id="element-8" />
        <Results data-id="element-9" />
        <Journey data-id="element-10" />
        <Program data-id="element-11" />
        <DiagnosticSection data-id="element-12" />
        <Tariffs data-id="element-13" />
        <Speaker data-id="element-14" />
        <Roadmap data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>
      <Footer data-id="element-17" />
      <SurveyModal data-id="element-18" />
    </div>;
}